import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Select from 'react-select';
import { getNames } from 'country-list';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import ReCAPTCHA from "react-google-recaptcha";
import './Contact.css';
import Footer from './footer';

const Contact = () => {
  const [formState, setFormState] = useState({
    first_name: '',
    last_name: '',
    company_name: '',
    work_email: '',
    phone_number: '',
    location: '',
    your_profile: '',
    message: '',
    privacy_agree: false
  });

  const [errors, setErrors] = useState({});
  const [isSent, setIsSent] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [captchaVerified, setCaptchaVerified] = useState(false);

  const countryOptions = getNames().map((country) => ({ label: country, value: country }));
  const profileOptions = [
    { label: 'Client', value: 'Client' },
    { label: 'Potential Client', value: 'Potential Client' },
    { label: 'Investor', value: 'Investor' },
    { label: 'Financial Analyst', value: 'Financial Analyst' },
    { label: 'Industry Analyst', value: 'Industry Analyst' },
    { label: 'Alliance Partner/Potential Alliance Partner', value: 'Alliance Partner/Potential Alliance Partner' },
    { label: 'Academician/Researcher', value: 'Academician/Researcher' },
    { label: 'Journalist/Media', value: 'Journalist/Media' },
    { label: 'Others', value: 'Others' },
  ];

  const validateFields = () => {
    let errors = {};
    if (!formState.first_name.trim()) errors.first_name = 'First Name is required';
    if (!formState.last_name.trim()) errors.last_name = 'Last Name is required';
    if (!formState.company_name.trim()) errors.company_name = 'Company Name is required';
    if (!formState.work_email.trim() || !/\S+@\S+\.\S+/.test(formState.work_email))
      errors.work_email = 'Valid email is required';
    if (!formState.phone_number) errors.phone_number = 'Phone Number is required';
    if (!formState.location) errors.location = 'Location is required';
    if (!formState.your_profile) errors.your_profile = 'Profile selection is required';
    if (!formState.message.trim()) errors.message = 'Message cannot be empty';
    // if (!captchaVerified) errors.captcha = 'Please verify you are not a robot';
    if (!formState.privacy_agree) errors.privacy_agree = 'You must agree to our terms';

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submit button clicked!");  // Debugging log
    setLoading(true);

    if (!validateFields()) {
      console.log("Validation errors:", errors);  // Debugging log
      setLoading(false);
      return;
    }

    console.log("Validation passed, preparing email...");

    const templateParams = {
      to_name: 'Admin',
      from_name: `${formState.first_name} ${formState.last_name}`,
      company_name: formState.company_name,
      work_email: formState.work_email,
      phone_number: formState.phone_number,
      location: formState.location,
      your_profile: formState.your_profile,
      message: formState.message,
    };

    console.log("Template Params:", templateParams);  // Debugging log

    emailjs.send('service_ds8cffd', 'template_sl8jj1b', templateParams, 'kamMtptEh3wrm0rDM')
      .then(() => {
        console.log("Email sent successfully!");
        setLoading(false);
        setIsSent(true);
        setFormState({ first_name: '', last_name: '', company_name: '', work_email: '', phone_number: '', location: '', your_profile: '', message: '', privacy_agree: false });
        // setCaptchaVerified(false);
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        console.error('Error:', error);
        setLoading(false);
      });
  };

  return (
    <>
      <div className="contact-page">
        <div className="contact-container">
          <h1>WRITE TO US</h1>
          <p className="contact-info">We're excited that you're reaching out to us!</p>

          {isSent ? (
            <div className="thank-you-message">
              <h2>Thank You!</h2>
              <p>Your message has been sent successfully. We’ll be in touch soon.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>

              <div className="form-group">
                <label htmlFor="first_name">First Name *</label>
                <input type="text" id="first_name" name="first_name" placeholder="Enter your first name" value={formState.first_name} onChange={(e) => setFormState({ ...formState, first_name: e.target.value })} required />
                {errors.first_name && <span className="error-text">{errors.first_name}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="last_name">Last Name *</label>
                <input type="text" id="last_name" name="last_name" placeholder="Enter your last name" value={formState.last_name} onChange={(e) => setFormState({ ...formState, last_name: e.target.value })} required />
                {errors.last_name && <span className="error-text">{errors.last_name}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="company_name">Company Name *</label>
                <input type="text" id="company_name" name="company_name" placeholder="Enter your company name" value={formState.company_name} onChange={(e) => setFormState({ ...formState, company_name: e.target.value })} required />
                {errors.company_name && <span className="error-text">{errors.company_name}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="work_email">Work Email *</label>
                <input type="email" id="work_email" name="work_email" placeholder="Enter your work email" value={formState.work_email} onChange={(e) => setFormState({ ...formState, work_email: e.target.value })} required />
                {errors.work_email && <span className="error-text">{errors.work_email}</span>}
              </div>

              <div className="form-group">
                <label>Phone Number *</label>
                <PhoneInput international defaultCountry="IN" value={formState.phone_number} onChange={(phone) => setFormState({ ...formState, phone_number: phone })} />
                {errors.phone_number && <span className="error-text">{errors.phone_number}</span>}
              </div>

              <div className="form-group">
                <label>Location *</label>
                <Select options={countryOptions} placeholder="Search country" onChange={(selectedOption) => setFormState({ ...formState, location: selectedOption.value })} />
                {errors.location && <span className="error-text">{errors.location}</span>}
              </div>

              <div className="form-group">
                <label>Your Profile *</label>
                <Select options={profileOptions} placeholder="Select your profile" onChange={(selectedOption) => setFormState({ ...formState, your_profile: selectedOption.value })} />
                {errors.your_profile && <span className="error-text">{errors.your_profile}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea id="message" name="message" placeholder="Enter your message" value={formState.message} onChange={(e) => setFormState({ ...formState, message: e.target.value })} required />
                {errors.message && <span className="error-text">{errors.message}</span>}
              </div>


              <div className="privacy-container">
                <br></br>
                <p className="privacy-text">
                  PERiTOSE Global Solutions, PVT Ltd. is committed to protecting and respecting your privacy, and we’ll only use your personal 
                  information to administer your account and to provide the products and services you requested from us. 
                  From time to time, we would like to contact you about our products and services, as well as other content 
                  that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to 
                  say how you would like us to contact you:
                </p>

                <br></br>

                <input type="checkbox" id="privacy_agree" checked={formState.privacy_agree} 
                  onChange={(e) => setFormState({ ...formState, privacy_agree: e.target.checked })} />
                <label htmlFor="privacy_agree">{" "}I agree to receive communications from PERiTOSE Global Solutions, PVT Ltd.</label>
                {errors.privacy_agree && <span className="error-text">{errors.privacy_agree}</span>}
              </div>


              {/* Need to work on CAPTCHA KEY*/}
              {/* <div className="recaptcha-container">
                <ReCAPTCHA sitekey="YOUR_SITE_KEY" onChange={() => setCaptchaVerified(true)} />
                {errors.captcha && <span className="error-text">{errors.captcha}</span>}
              </div> */}

              {/* <button type="submit" className="submit-btn">{loading ? "Sending..." : "Submit"}</button> */}
              <button type="submit" className="submit-btn" onClick={() => console.log("Submit button pressed!")}>{loading ? "Sending..." : "Submit"}</button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
